import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApprovalTasks } from '../../redux/features/taskManagementSlice';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../components/datagrid/GridToolBar';
import { taskApprovalColumns } from './ApprovalTaskTblHeader';
import { Box, Button, TextField } from '@mui/material';
import { ApproveButton } from '../../components/mui/Buttons/Buttons';
import ApproveTask from './ApproveTask';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const TaskApprovalView = () => {
  const dispatch = useDispatch();
  const { loading, approvalData } = useSelector((state) => state.taskManagement);
  const [gridSize, setGridSize] = useState(10);
  const [approval, setApproval] = useState(false);
  const [approvalId, setApprovalId] = useState(null);
  const [value, setValue] = useState(dayjs());

  useEffect(() => {
    dispatch(getApprovalTasks(dayjs(value).format('YYYY-MM')));
  }, [dispatch, value]);

  const handleUpdate = (task_approval_id) => {
    setApproval(true);
    setApprovalId(task_approval_id);
  };
  const columns = [
    ...taskApprovalColumns,
    {
      field: 'Approve',
      headerName: 'Approve',
      width: 180,
      renderCell: (params) => (
        <ApproveButton size={'small'} action={() => handleUpdate(params.row.task_approval_id)}>
          Approve
        </ApproveButton>
      ),
    },
  ];
  return (
    <GlobalWrapper
      title={'Task Approval'}
      actions={
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={['year', 'month']}
              value={value}
              onChange={(newValue) => setValue(newValue)}
              format="MMM YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      }
    >
      <DataGrid
        components={{ Toolbar: CustomGridToolbar }}
        rows={approvalData}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.serialNumber}
        pageSize={gridSize}
        autoHeight
        rowsPerPageOptions={[5, 10, 25, 50]}
        onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
        getRowHeight={() => 'auto'}
      />
      <ApproveTask approvalId={approvalId} open={approval} date={value} setOpen={setApproval} />
    </GlobalWrapper>
  );
};

export default TaskApprovalView;
